import { ButtonLink } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledButtonLink = styled(ButtonLink)`
  padding-top: 8px;
  [data-button-link-label] {
    gap: 4px;
  }

  &:hover,
  &:focus {
    outline: none;
    text-decoration: none;
  }
`;
